import { useEffect, useState } from 'react';
import { useMenuContext } from '../../context';
import BMTriggerButton from './BMTriggerButton';
import IoTMTriggerButton from './IoTMTriggerButton';

// Constants for button positioning
const BUTTON_SPACING = 40;
const IOTM_BUTTON_SPACING = 70;
const BASE_TOP_POSITION = 95;

type Props = {
  onBMOpen?: () => void;
  onIoTOpen?: () => void;
  onBMClose?: () => void;
  onIoTClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  menuIsOpen: boolean;
  bmItems?: any[];
  handleSelectMenu?: (menu: any) => void;
  libraryIconsBaseUrl: string;
  awsIconUrl: string;
};

export default function TriggerButtons({
  onBMOpen,
  onBMClose,
  onIoTClose,
  onIoTOpen,
  setMenuIsOpen,
  menuIsOpen,
  bmItems,
  handleSelectMenu,
  libraryIconsBaseUrl,
  awsIconUrl,
}: Props) {
  const { open } = useMenuContext();
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  useEffect(() => {
    if (open) {
      setHasBeenOpened(true);
    }
  }, [open]);

  return (
    <>
      {onBMOpen && (
        <>
          {bmItems?.map((item, i, filteredArray) => {
            const topPosition = BASE_TOP_POSITION + (i * BUTTON_SPACING);
            const isFirst = i === 0;
            const isLast = i === filteredArray.length - 1;
            return (
              <BMTriggerButton
                key={i}
                item={item}
                libraryIconsBaseUrl={libraryIconsBaseUrl}
                awsIconUrl={awsIconUrl}
                top={topPosition}
                index={i}
                isFirst={isFirst}
                isLast={isLast}
                onOpen={() => {
                  if (handleSelectMenu) {
                    handleSelectMenu(item);
                  }
                  onBMOpen();
                }}
                onClose={onBMClose}
                setMenuIsOpen={setMenuIsOpen}
                hasBeenOpened={hasBeenOpened}
                menuIsOpen={menuIsOpen}
              />
            );
          })}
        </>
      )}
      {onIoTOpen && (
        <IoTMTriggerButton
          onOpen={onIoTOpen}
          onClose={onIoTClose}
          setMenuIsOpen={setMenuIsOpen}
          hasBeenOpened={hasBeenOpened}
          menuIsOpen={menuIsOpen}
          top={onBMOpen && bmItems?.length ? BASE_TOP_POSITION + (bmItems.length * IOTM_BUTTON_SPACING) : BASE_TOP_POSITION}
        />
      )}
    </>
  );
}
